module.exports = __webpack_public_path__ + "img/50n.c48af086.svg";